(function () {
  'use strict';

  angular
    .module('app.loadingbar', []);
})();
